<template>
    <div>
        <b-overlay :show="loading || processingAction" rounded="lg" opacity="0.6">
            <b-card v-if="error" class="text-center m-2">
                <b-alert variant="danger" show class="m-0">
                    <h4>Bir Hata Oluştu</h4>
                    <p class="mb-0">{{ error }}</p>
                </b-alert>
            </b-card>

            <b-card v-else-if="success" class="text-center m-2">
                <b-alert variant="success" show class="m-0">
                    <h4>İşlem Tamamlandı</h4>
                    <p class="mb-0">{{ success }}</p>
                </b-alert>
            </b-card>

            <incident-ott-detail v-else-if="details" :details="details" :processing="processingAction" v-on:approve="openApproveModal" v-on:reject="openRejectModal" class="m-1" />
        </b-overlay>

        <b-modal id="ott-action-modal" :title="actionApprove ? 'Vukuat İşlemini Onayla' : 'Vukuat İşlemini Reddet'" hide-footer no-close-on-backdrop no-close-on-esc>
            <label for="action-desc">Lütfen açıklama belirtin (zorunlu):</label>
            <b-form-textarea id="action-desc" v-model="actionDescription" rows="4" no-resize></b-form-textarea>
            <div class="text-right mt-3">
                <b-button variant="secondary" class="mr-2" v-on:click="$bvModal.hide('ott-action-modal')">İptal</b-button>
                <b-button :variant="actionApprove ? 'success' : 'danger'" v-on:click="submitAction" :disabled="!trimmedActionDescription || processingAction">
                    <b-spinner v-if="processingAction" small></b-spinner>
                    {{ actionApprove ? "Onayla" : "Reddet" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { BCard, BAlert, BOverlay, BModal, BFormTextarea, BButton, BSpinner } from "bootstrap-vue";
import IncidentOperationsApi from "@/api/incident-operations";
import IncidentOttDetail from "./components/IncidentOttDetail.vue";

export default {
    components: {
        BCard,
        BAlert,
        BOverlay,
        BModal,
        BFormTextarea,
        BButton,
        BSpinner,
        IncidentOttDetail,
    },
    data() {
        return {
            ott: this.$route.params.q,
            loading: true,
            error: null,
            success: null,
            details: null,
            processingAction: false,
            actionDescription: "",
            actionApprove: null,
            GENERIC_ERROR: "İşlem tamamlanamadı. Bu link daha önce kullanılmış veya geçersiz olabilir.",
        };
    },
    mounted() {
        this.fetchDetails();
    },
    computed: {
        trimmedActionDescription() {
            return (this.actionDescription || "").trim();
        },
    },
    methods: {
        fetchDetails() {
            this.loading = true;
            IncidentOperationsApi.GetTaskWithOTT(this.ott)
                .then((res) => {
                    if (res.data.Success) {
                        this.details = res.data.Data;
                    } else {
                        this.error = res.data.Message || "Geçerli bir vukuat kaydı bulunamadı veya linkin süresi dolmuş.";
                    }
                })
                .catch((err) => {
                    this.error = "API ile iletişim kurulamadı. Lütfen daha sonra tekrar deneyin.";
                    this.$result(null, err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        openApproveModal() {
            this.openActionModal(true);
        },
        openRejectModal() {
            this.openActionModal(false);
        },
        openActionModal(approve) {
            this.actionApprove = approve;
            this.actionDescription = "";
            this.$bvModal.show("ott-action-modal");
        },
        submitAction() {
            if (!this.trimmedActionDescription || this.actionApprove === null) return;
            this.changeApprovalStatus(this.actionApprove, this.trimmedActionDescription);
        },
        changeApprovalStatus(approve, description = null) {
            const cleanDescription = (description || "").trim();
            if (!cleanDescription) return;

            this.processingAction = true;
            if (this.$bvModal) this.$bvModal.hide("ott-action-modal");

            const payload = { OTT: this.ott, Approve: approve, Description: cleanDescription };
            IncidentOperationsApi.ChangeApprovalStatusWithOTT(payload)
                .then((res) => {
                    this.$result(res);
                    if (!res.data.Success) {
                        this.error = res.data.Message || this.GENERIC_ERROR;
                    } else {
                        this.details = null;
                        this.success = approve ? "İşlem başarıyla onaylandı." : "İşlem başarıyla reddedildi.";
                    }
                })
                .finally(() => {
                    this.processingAction = false;
                });
        },
    },
};
</script>
